import { useMemo } from "react";
import { useAppSelector } from "../../framework/customStore";
import { makeSelectSalaryPeriodByIdAndDate } from "../../store/salaryPeriodSlice";

export const useSelectSalaryPeriodByIdAndDate = (id: string, date: string) => {
    const state = useAppSelector((state) => state.salaryPeriod);
    const selectSalaryPeriodByIdAndDate = useMemo(() => makeSelectSalaryPeriodByIdAndDate(), []);
    return selectSalaryPeriodByIdAndDate(state, id, date);
};
